const ALLOWED_HOSTNAMES = [
  "test-chat.verbaflo.com",
  "stg-chat.verbaflo.com",
  "chat.verbaflo.com",
  "chat.us.verbaflo.com",
];

function isScopedStorageEnabled(): boolean {
  const hostname = window?.location?.hostname;
  return hostname ? ALLOWED_HOSTNAMES.includes(hostname) : false;
}

export function getTenantScope(): string {
  const pathSegments = window?.location?.pathname
    ?.split("/")
    .filter((segment) => segment !== "");

  return pathSegments[0] || "root";
}

function scopedKey(key: string): string {
  if (!isScopedStorageEnabled()) {
    return key;
  }
  return `${getTenantScope()}:${key}`;
}

export const scopedLocalStorage = {
  key: (key: string) => scopedKey(key),
  getItem: (key: string): string | null => {
    return localStorage.getItem(scopedKey(key));
  },
  setItem: (key: string, value: string): void => {
    localStorage.setItem(scopedKey(key), value);
  },
  removeItem: (key: string): void => {
    localStorage.removeItem(scopedKey(key));
  },
};

export const scopedSessionStorage = {
  key: (key: string) => scopedKey(key),
  getItem: (key: string): string | null => {
    return sessionStorage.getItem(scopedKey(key));
  },
  setItem: (key: string, value: string): void => {
    sessionStorage.setItem(scopedKey(key), value);
  },
  removeItem: (key: string): void => {
    sessionStorage.removeItem(scopedKey(key));
  },
};
